import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=727d5c18"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=727d5c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports